import { render, staticRenderFns } from "./BizInsuranceExcelCompareList.vue?vue&type=template&id=1657cd4d&"
import script from "./BizInsuranceExcelCompareList.vue?vue&type=script&lang=js&"
export * from "./BizInsuranceExcelCompareList.vue?vue&type=script&lang=js&"
import style0 from "./BizInsuranceExcelCompareList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports